export default __webpack_public_path__ + "static/david-jones-group-45bc9a1067d0b2a907fdf19f90c548a9.webp";